import { buildDisplayHolidayPath } from '@/routing/discoveryPaths';

export const getPopularCategoryHref = (
  category: 'sequence' | 'display',
  holiday: string,
): string => {
  if (category === 'sequence') {
    return `/sequences/search?holiday=${encodeURIComponent(holiday)}`;
  }

  return buildDisplayHolidayPath(holiday.toLowerCase());
};
